import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { PriceInformation } from '../models/price-information';
import { PriceService } from '../services/price.service';
import { LanguageService } from '../services/language.service';
import { StartupService } from '../services/startup.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigurationService } from '../services/configuration.service';

@Component({
  selector: 'app-price-information',
  templateUrl: './price-information.component.html',
  styleUrls: ['./price-information.component.scss'],
})
export class PriceInformationComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  priceLoading: boolean;
  price: number;
  invalid = false;
  showPrices: boolean;

  constructor(
    private priceService: PriceService,
    private languageService: LanguageService,
    private changeDetector: ChangeDetectorRef,
    private startupService: StartupService,
    private configurationService: ConfigurationService
  ) {}

  ngOnInit() {
    this.startupService.priceEnabledSetting$.pipe(takeUntil(this.unsubscribe)).subscribe((enabled: boolean) => {
      this.showPrices = enabled;
    });
    this.priceService.priceInformation$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((priceInformation: PriceInformation) => {
        this.updatePrice(priceInformation);
      });

    this.configurationService.furthestStepVisitedUpdated$.subscribe(() => {
      this.changeDetector.detectChanges();
    });
  }
  get visible(): boolean {
    return this.showPrices && this.configurationService.furthestStepVisited > 2;
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.unsubscribe();
  }

  updatePrice(priceInformation: PriceInformation) {
    if (priceInformation.loading) {
      this.priceLoading = true;
      this.changeDetector.detectChanges();
      return;
    }
    this.priceLoading = false;
    this.price = priceInformation.price;
    if (priceInformation.invalid) {
      this.invalid = true;
    } else {
      this.invalid = false;
    }

    this.changeDetector.detectChanges();
  }
  get currentLocale() {
    return this.languageService.currentLanguage;
  }
}
